import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

import theme from './theme';

export * from './styled.default';

export const CartItemEditButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CartItemDescription = styled.p`
  color: ${theme.cartItemDescriptionColor};
  font-size: 0.85rem;
  font-weight: ${Styles.fontWeight.normal};
  margin: 0;
`;

export const ItemFreeQuantityDescription = styled.p`
  margin: 0 0 1rem;
  font: ${brandFont.copyTwo};
`;
